import { Suspense, useEffect, useState, type ComponentType } from 'react';
import { MDA_REGISTRY, preloadMdaDemo } from '../lib/mdaRegistry';
import { SiteFadeInMount } from './SiteFadeIn';

interface LazyMdaDemoProps {
  demoId: string;
  fallbackClassName?: string;
}

function DemoSuspenseFallback({ className }: { className: string }) {
  return <div className={`opacity-0 ${className}`} aria-hidden="true" />;
}

interface LoadedMdaDemoProps {
  DemoComponent: ComponentType;
}

function LoadedMdaDemo({ DemoComponent }: LoadedMdaDemoProps) {
  return (
    <SiteFadeInMount>
      <DemoComponent />
    </SiteFadeInMount>
  );
}

export function LazyMdaDemo({
  demoId,
  fallbackClassName = 'h-full w-full',
}: LazyMdaDemoProps) {
  const entry = MDA_REGISTRY[demoId];
  const DemoComponent = entry?.component;

  useEffect(() => {
    preloadMdaDemo(demoId);
  }, [demoId]);

  if (!DemoComponent) {
    return null;
  }

  return (
    <Suspense fallback={<DemoSuspenseFallback className={fallbackClassName} />}>
      <LoadedMdaDemo DemoComponent={DemoComponent} />
    </Suspense>
  );
}

export function lazyMdaHoverHandlers(demoId: string | null | undefined) {
  if (!demoId) {
    return {};
  }
  return {
    onMouseEnter: () => preloadMdaDemo(demoId),
    onFocus: () => preloadMdaDemo(demoId),
  };
}
